import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useClientAuth } from "@/lib/clientAuth";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const nav = useNavigate();
  const { setClient } = useClientAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) { nav("/portal/login", { replace: true }); return; }
    const sessionId = decodeURIComponent(match[1]);

    (async () => {
      try {
        const { data } = await api.post("/auth/session", { session_id: sessionId });
        if (data?.user) setClient(data.user);
        window.history.replaceState(null, "", window.location.pathname);
        nav("/portal", { replace: true });
      } catch (error) {
        console.error("Google session exchange failed:", error);
        nav("/portal/login?err=google", { replace: true });
      }
    })();
  }, [nav, setClient]);

  return (
    <div data-testid="auth-callback" className="min-h-screen pt-32 text-center text-slate-500">
      Signing you in with Google…
    </div>
  );
}
